const features = [
  {
    icon: 'ri-speed-up-line',
    title: '极速更新',
    desc: '7×24小时全天候追踪热点，重大事件15分钟内首条快讯上线，让你永远走在吃瓜第一线。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '信息核验',
    desc: '每条爆料均经多渠道交叉验证，标注信息来源类型，避免误传谣言，做有态度的吃瓜平台。',
  },
  {
    icon: 'ri-eye-off-line',
    title: '隐私保护',
    desc: '爆料人信息端到端加密，匿名投稿通道保证绝对安全，让每一个知情者都能放心发声。',
  },
  {
    icon: 'ri-global-line',
    title: '覆盖全面',
    desc: '涵盖娱乐圈、社会热点、财经内幕、科技泄密等30+话题领域，一站在手，瓜遍天下。',
  },
  {
    icon: 'ri-group-line',
    title: '社区互动',
    desc: '活跃的吃瓜社区氛围，理性讨论拒绝网络暴力，百万网友与你一起分享吃瓜的乐趣。',
  },
];

export default function Features() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10">
          <span className="text-sm text-accent-600 font-medium bg-accent-50 px-3 py-1 rounded-full">平台优势</span>
          <h2 className="mt-3 text-2xl md:text-3xl font-heading font-bold text-foreground-950">平台特色</h2>
          <p className="mt-2 text-sm text-foreground-500">为什么数百万人选择911爆料网</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((feature, index) => (
            <div key={index} className="bg-background-50 border border-background-200/70 rounded-xl p-6 text-center hover:border-primary-200 transition-colors group cursor-pointer">
              <div className="w-14 h-14 mx-auto flex items-center justify-center bg-primary-50 rounded-xl group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-2xl text-primary-600`}></i>
              </div>
              <h3 className="mt-4 text-base font-heading font-bold text-foreground-900">{feature.title}</h3>
              <p className="mt-2 text-xs text-foreground-500 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}